<template>
    <div class="my-6">
        <div>
            <div class="card mx-6">
                <tabs
                    @selectedTab="setSelectedTab"
                    tabNavClasses="nav-fill flex-column flex-sm-row my-4 mx-4"
                    :color="color.primary">
                    <tab-pane v-for="(tabPane, index) in tabPanes" :key="index" :id="tabPane.id">
                        <template #title><span class="nch--tab">{{$t(tabPane.title)}}</span></template>
                        <component
                            :is="tabPane.component"
                        />
                    </tab-pane>
                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
import TabPane from '../argon/components/Tabs/Tab';
import Tabs from '../argon/components/Tabs/Tabs';
import Invoices from './InvoiceComponents/Invoices';
import Recurrences from './RecurrenceComponents/Recurrences';

export default {
    name: 'Financial',
    components: {
        TabPane,
        Tabs,
        Invoices,
        Recurrences,
    },
    data() {
        return {
            currentTab: 'invoice',
        };
    },
    computed: {
        tabPanes() {
            if (this.isTable) {
                return [
                    {
                        id: 'invoice',
                        title: 'billing.invoice.invoice',
                        component: 'Invoices',
                    },
                    {
                        id: 'recurrence',
                        title: 'billing.recurrence.recurrence',
                        component: 'Recurrences',
                    },
                ];
            }
            return [
                {
                    id: 'invoiceMobile',
                    title: 'billing.invoice.invoice',
                    component: 'Invoices',
                },
                {
                    id: 'recurrenceMobile',
                    title: 'billing.recurrence.recurrence',
                    component: 'Recurrences',
                },
            ];
        },
        isTable() {
            if (this.$mq === 'lg') return true;
        },
        color() {
            return this.$store.getters.COLOR;
        },
    },
    methods: {
        setSelectedTab(tab) {
            this.currentTab = tab;
        },
    },
};
</script>

<style>

</style>
